import React from "react";
import "./CompletedProgrammeCard.scss";

import { useLocation } from "react-router-dom";

import useCompletedSteps from "../../hooks/useCompletedSteps";
import Stepper from "../../atoms/Stepper";
import { ReactComponent as CelebrationTrophyLeft } from "../../../assets/img/celebration_trophy_left.svg";
import { ReactComponent as CelebrationTrophyRight } from "../../../assets/img/celebration_trophy_right.svg";
import { UserProgrammeOverview } from "../../../types/UserProgrammeOverview";

interface Props {
  programmeOverview: UserProgrammeOverview | undefined;
}

const CompletedProgrammeCard: React.FC<Props> = ({
  programmeOverview,
}: Props) => {
  const completedSteps = useCompletedSteps(programmeOverview?.steps);
  const steps = programmeOverview.programme.numberOfSteps - 1;

  const location = useLocation();
  const isMyPath = location.pathname.includes("my-path") ? true : false;

  return (
    <>
      {!isMyPath && programmeOverview !== undefined && (
        <div className="hero-card__completed-celebration">
          <CelebrationTrophyLeft />
          <Stepper
            totalSteps={steps}
            completedSteps={completedSteps}
            currentStep={steps}
          />
          <CelebrationTrophyRight />
        </div>
      )}
      <div className="hero-card__completed-programme">
        <h2>Incredible! You've completed your {steps} week programme</h2>
      </div>
    </>
  );
};

export default CompletedProgrammeCard;
